import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { CardBody, Container,} from 'reactstrap';
import { Card } from 'reactstrap';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSelector, useDispatch } from "react-redux";
import { StoreExecutiveRequisition } from '../../store/executive/action';
import { productCategoryObj } from '../helper';
import { toast } from 'react-toastify';
import { products } from '../../api/requisition';
import { useNavigate,useLocation } from 'react-router-dom';
import { StorePageHeaderName } from '../../store/pageHeader/action';

const NewCreateRequisition = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const requisitionData = useSelector((state) => state.executive);

    // State for rows of products
    const [productCategory, setProductCategory] = useState(productCategoryObj[0]);

    const [rows, setRows] = useState([
        {
            productName: '',
            productObj: null,
            quantity: '',
            value: 0,
            mop: 0,
            productOptions: [], // Initial empty
            errors: {
                productNameError: '',
                quantityError: '',
                valueError: ''
            }
        }
    ]);
    const [prevRoute, setPrevRoute] = useState('');

  useEffect(() => {
    const handlePageLoad = () => {
      const navigationEntries = performance.getEntriesByType('navigation');
      if (navigationEntries.length > 0) {
        const navigationType = navigationEntries[0].type;
        if (navigationType === 'reload') {
          // If the page is refreshed, reset the location state
          navigate(location.pathname, { replace: true, state: { ...location.state, prevRoute: '' } });
        }
      } else {
        setPrevRoute(location.state?.prevRoute || '');
      }
    };

    handlePageLoad();
  }, [location, navigate]);
  
    useEffect(()=>{
        dispatch(StorePageHeaderName('Create Requisition'))

    },[])

    useEffect(() => {
        const fetchData = async () => {
            if (location.state && location.state.prevRoute === '/executive/add-requisition' && requisitionData.requisitionData.length > 0) {
                setProductCategory(requisitionData.productCategory);
                setRows([...requisitionData.requisitionData]);
            }
        };
    
        fetchData();
    }, [location.state, requisitionData]);
    


    const handleProductCategoryChange = (event, newValue) => {
        setProductCategory(newValue);


        rows.map((row, mainRowIndex) => {
            if (!row.productObj) {
                console.log("mainRowIndex--",mainRowIndex, "row--",row)
              fetchProductList(newValue,mainRowIndex, rows);
            }
          });
        
         
        
    };


    const handleAddRow = async() => {
        const isValid = validateAllRows();

        if (!isValid) {
            return;
        }

        const newRow = { productName: '', quantity: '', mop: 0, value: 0, productObj: null, productOptions: [],
            errors: {  // Initialize errors object here
                productNameError: '',
                quantityError: '',
                valueError: ''
            }};
       const updatedRows = [...rows, newRow];
       const newIndex = updatedRows.length - 1;
       await fetchProductList(productCategory,newIndex, updatedRows);
    };
    const handleDeleteRow = (index) => {
        if (rows.length === 1) {
            return; 
        }
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
    };

    const handleProductNameChange = (index, newValue) => {
        
        const updatedRows = [...rows];
        updatedRows[index].productObj = newValue
        updatedRows[index].quantity = '';
        updatedRows[index].mop = newValue ? newValue.Mop: 0;
        updatedRows[index].value = 0;
        updatedRows[index].errors.productNameError = '';
        updatedRows[index].productName = newValue ? newValue.label: '';
        setRows(updatedRows);
    };

    const handleQuantityChange = (index, newValue) => {
        newValue = parseInt(newValue, 10);

        if (isNaN(newValue) || newValue <= 0) {
            newValue = 0;
        }
        
     
        const updatedRows = [...rows];

        if (newValue > 9999) {
            const updatedRows = [...rows];
            updatedRows[index].errors.quantityError = 'Quantity must be between 0 and 9999';
            setRows(updatedRows);
            return;
        }


        updatedRows[index].quantity = newValue;
     
        updatedRows[index].value = newValue *  updatedRows[index].productObj.Dp
      
        if(  updatedRows[index].value > 0){
            updatedRows[index].errors.valueError = '';

        }
        if(newValue > 0 && newValue <= 9999){
            updatedRows[index].errors.quantityError = '';

        }

        setRows(updatedRows);
    };

    const handleValueChange = (index, newValue) => {
        const updatedRows = [...rows];
        updatedRows[index].value = newValue;
        setRows(updatedRows);
    };

    const goToRequisition = () => {
        const isValid = validateAllRows();
        if (!isValid) {
            return;
        }
        const resultPayload = {
            storedRows: rows,
            productCategory
        }
        dispatch(StoreExecutiveRequisition(resultPayload))
        navigate("/executive/add-requisition", { state: { requisition: rows } });
    };
    const fetchProductList = async(product_category,index, updatedrows,  newInputValue)=>{
        const updatedRows = updatedrows

        try {
            let product_list = []
            if(newInputValue && newInputValue !== ''){
                 product_list = await products({ search_type: product_category.value, search_item: newInputValue});
            }
            else{

                 product_list = await products({ search_type: product_category.value});
            }

            if(product_list.statusCode === 200 && product_list.data.productList[0].length > 0){
                console.log('product_list.data.productList[0]---',product_list.data.productList[0])
                updatedRows[index].productOptions = product_list.data.productList[0].map(product => ({
                    label: product.ItemName,
                    value: product.ItemNo,
                    productName: product.ItemName,
                    Mop: product.Mop,
                    Dp: product.Dp,
                    Ptype:product.Ptype,
                    Vertical: product.Vertical,
                    Itemseg: product.Itemseg,
                    Category: product.Category,
                    vcode: product.Vcode,
                    vname: product.Vname,
                    vtype: product.Vtype
                }));
                const selectedValues = new Set();
                updatedRows.forEach((row, idx) => {
                    if (idx !== index && row.productObj) {
                        if( row.productObj){
                            selectedValues.add(row.productObj.value);
                        }
    
                    }
                });
    
                updatedRows[index].productOptions = updatedRows[index].productOptions.filter(option =>
                    !selectedValues.has(option.value)
                );
            }
            else {
                console.log('Hiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii',index,  updatedRows[index])
                updatedRows[index].productOptions = []
                updatedRows[index].productObj = null

            }
            // const selectedValues = new Set();
            // updatedRows.forEach((row, idx) => {
            //     if (idx !== index && row.productObj) {
            //         if( row.productObj){
            //             selectedValues.add(row.productObj.value);
            //         }

            //     }
            // });

            // updatedRows[index].productOptions = updatedRows[index].productOptions.filter(option =>
            //     !selectedValues.has(option.value)
            // );

        }catch(error){
            console.log('error in fetching product list executive bucket', error)
            toast.error('Something went wrong')
        }
      
        finally {
            setRows([...updatedRows]); 
        }
    }
    // useEffect(()=>{
    //     // if(requisitionData.requisitionData.length ===0){
    //     if(!location.state || (location.state && location.state.prevRoute !== '/executive/add-requisition')){

    //         fetchProductList(productCategory,0, rows)
    //     }
        
    // },[productCategory])
    useEffect(()=>{
        // if(requisitionData.requisitionData.length ===0){
        if(!location.state || (location.state && location.state.prevRoute !== '/executive/add-requisition')){

            fetchProductList(productCategory,0, rows)
        }
        
    },[])

    const handleProductNameInputChange = async (index, newInputValue) => {
        const updatedRows = [...rows];
        await fetchProductList(productCategory,index, updatedRows,  newInputValue);
    };
    const validateAllRows = () => {
        const errors = [];
        rows.forEach((row, index) => {
            let rowErrors = {
                productNameError: '',
                quantityError: '',
                valueError: ''
            };
    
            if (!row.productObj) {
                rowErrors.productNameError = 'Product Name is required';
            } else if (!row.mop) {
                rowErrors.productNameError = 'Product\'s MOP is empty';
            }

            
    
            if (row.quantity <= 0) {
                rowErrors.quantityError = 'Quantity should be greater than 0';
            }

            if (row.quantity >9999) {
                rowErrors.quantityError = 'Quantity should be less than 9999';
            }
    
            if (row.value <= 0) {
                rowErrors.valueError = 'Value should be greater than 0';
            }
    
            errors[index] = rowErrors;
        });
    
        // Update rows state with errors
        setRows(prevRows => (
            prevRows.map((row, index) => ({
                ...row,
                errors: errors[index]  // Assign errors to each row
            }))
        ));
    
        // Return true if all errors are empty strings, false otherwise
        return errors.every(error => (
            error.productNameError === '' &&
            error.quantityError === '' &&
            error.valueError === ''
        ));
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                <div className='mb-3'>
                 <h3 className="requisition_text mb-0">Requisition Form</h3>
                </div>
                    <Card className='mb-3'>
                        <CardBody>
                            <div className='d-flex align-items-center mb-2'>
                                <div>
                                    <p className='mb-0 me-2 requisition_type_text'>Requisition Type : </p>
                                </div>
                                <div>
                                    <Autocomplete
                                        className="create_requisition_field"
                                        id={`product-category`}
                                        sx={{ width: 150 }}
                                        options={productCategoryObj}
                                        value={productCategory}
                                        onChange={handleProductCategoryChange}
                                        clearIcon={null} // This will hide the cancel icon

                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Type"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div>
                                {rows.map((row, index) => (
                                    <div key={index} className='d-flex gap-4 align-items-center flex-wrap w-100'>
                                        <div className='mt-3 create_requistion d-flex flex-wrap' key={index} style={{ gap: '10px', marginBottom: '5px', padding: '15px', backgroundColor: '#FAFDFF', border: '1px solid #C3E8FF', borderRadius: '5px',width:'100%'  }}>
                                        <Grid container spacing={1}>
                                        <Grid item xs={4}>
                                            <Autocomplete
                                                id={`product-name-${index}`}
                                                // sx={{ minWidth: 450 }}
                                                sx={{width:'100%'}}
                                                className="create_requisition_field"
                                                options={row.productOptions} // Replace with your product options
                                                value={row.productObj}
                                                onChange={(event, newValue) => handleProductNameChange(index, newValue)}
                                                 onInputChange={(event, newInputValue) => handleProductNameInputChange(index, newInputValue)} // Add this line
                                                isOptionEqualToValue={(option, value) => option.value === value.value} // Customize the equality test

                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Product Name"
                                                    />
                                                )}

                                            />
                                            {row.errors.productNameError && <div style={{ color: 'red' }}>{row.errors.productNameError}</div>}

                                        </Grid>
                                        <Grid item xs={4}>

                                            <TextField
                                                id={`quantity-${index}`}
                                                label="Quantity"
                                                variant="outlined"
                                                className="create_requisition_textfield"
                                                value={row.quantity}
                                                onChange={(event) => handleQuantityChange(index, event.target.value)}
                                                // sx={{ minWidth: 260 }}
                                                sx={{width:'100%'}}
                                                disabled={!row.productObj} // Disable if productObj is not selected

                                            />
                                            {row.errors.quantityError && <div style={{ color: 'red' }}>{row.errors.quantityError}</div>}
                                        </Grid>

                                        <Grid item xs={3}>

                                            <TextField
                                                id={`value-${index}`}
                                                label="Value"
                                                variant="outlined"
                                                className="create_requisition_textfield"
                                                value={row.value}
                                                onChange={(event) => handleValueChange(index, event.target.value)}
                                                // sx={{ minWidth: 260 }}
                                                sx={{width:'100%'}}
                                                disabled={true} // Disable if productObj is not selected

                                            />
                                            {row.errors.valueError && <div style={{ color: 'red' }}>{row.errors.valueError}</div>}
                                        </Grid>

                                        {rows.length > 1 && (
                                           <Grid item xs={1}>
                                            <div className='d-flex align-items-center mt-2'>
                                                <HighlightOffIcon onClick={() => handleDeleteRow(index)} color='error' />
                                            </div>
                                           </Grid>
                                        )}
                                    </Grid>
                                    </div>
                                    </div>
                                ))}
                            </div>
                            <div style={{ width: 'calc(10% - 5px)', marginTop: '8px' }}>
                                <button className='add_more_button' onClick={handleAddRow}>+ Add More</button>
                            </div>
                        </CardBody>
                    </Card>
                    <div className='mb-2' style={{ display: 'flex', justifyContent: 'end' }}>
                        <button className="save_button" variant="contained" onClick={goToRequisition}>Save</button>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default NewCreateRequisition;
